import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import {
    MainViewContainer,
    MainViewHeader,
    HeaderText,
    SearchInputContainer,
    SearchInput,
    MainViewFooter
} from '../styled/MainView';

import Icon from '../styled/Icon';
import Table from '../styled/Table';
import Button from '../styled/Button';
import Confirmation from '../styled/Confirmation';

import PartnerForm from '../PartnerForm';
import PartnerEditForm from '../PartnerForm/PartnerEditForm';
import PartnerOverview from '../PartnerOverview';

class PartnerTable extends Component {
    state = {
        searchQuery: '',
        searchResults: []
    };

    componentDidMount() {
        const { ui } = this.props.store;
        ui.setActiveView(ui.routes.partners);
    }

    searchPartners = async searchQuery => {
        const { app } = this.props.store;

        const partners = await app.api.partners.search({
            name: searchQuery,
            email: searchQuery,
            phoneNr: searchQuery
        });

        this.setState(() => ({ searchResults: partners.data, searchQuery }));
    };

    loadMorePartners = async () => {
        const { partners } = this.props.store;

        await partners.fetchPartners();
    };

    render() {
        const { store } = this.props;
        const { searchQuery, searchResults } = this.state;

        const DeleteConfirmation = ({ row }) => (
            <Confirmation
                message="Kas oled kindel, et soovid partneri kustutada?"
                description="Saad partneri kustutada vaid siis, kui ta pole ühegi kauba või arvega seotud."
                onConfirm={() => store.partners.deletePartner(row.id)}
            />
        );

        const columns = [
            {
                width: '2rem',
                value: row => (
                    <Icon
                        onClick={() => store.ui.showModal(<PartnerOverview partner={row} />)}
                        tooltip="Vaata partnerit"
                        type="eye"
                        size="1.25rem"
                    />
                ),
                header: ''
            },
            {
                width: '7.5rem',
                value: row => row.partnerType.name,
                header: 'Tüüp',
                attr: 'partnerType.name'
            },
            { width: '', value: row => row.name, header: 'Nimi', bold: true, attr: 'name' },
            {
                width: '10rem',
                value: row => row.phoneNr || '-',
                header: 'Telefon',
                attr: 'phoneNr'
            },
            {
                width: '15rem',
                value: row => row.email || '-',
                header: 'E-post',
                attr: 'email'
            },
            {
                width: '2rem',
                value: row => (
                    <Icon
                        onClick={() => store.ui.showModal(<DeleteConfirmation row={row} />)}
                        tooltip="Kustuta partner"
                        type="trashcan"
                        size="1.25rem"
                    />
                ),
                header: ''
            },
            {
                width: '2rem',
                value: row => (
                    <Icon
                        onClick={() => store.ui.showModal(<PartnerEditForm partner={row} />)}
                        tooltip="Muuda partnerit"
                        type="edit"
                        size="1.25rem"
                    />
                ),
                header: ''
            }
        ];

        return (
            <MainViewContainer>
                <MainViewHeader>
                    <HeaderText>Partnerid</HeaderText>
                    <SearchInputContainer>
                        <SearchInput
                            placeholder="Otsi partnerit"
                            type="text"
                            value={searchQuery}
                            onChange={query => this.searchPartners(query)}
                        />
                        <Icon type="search" size="1.5rem" />
                    </SearchInputContainer>
                </MainViewHeader>
                <Table
                    /* onScrollToBottom={this.loadMorePartners} */
                    columns={columns}
                    data={searchQuery ? searchResults : store.partners.partners}
                />
                <MainViewFooter>
                    <Button
                        value="+ Uus partner"
                        onClick={() => store.ui.showModal(<PartnerForm />)}
                    />
                </MainViewFooter>
            </MainViewContainer>
        );
    }
}

export default inject('store')(observer(PartnerTable));
